import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { CreateInvoiceForm } from "./create-invoice-form";
import { Button } from "@/components/ui/button";

export function CreateInvoiceButton() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="default">Create Invoice</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[600px] max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Create Invoice</DialogTitle>
        </DialogHeader>
        <CreateInvoiceForm />
      </DialogContent>
    </Dialog>
  );
}
